<template>
  <footer class="bg-light d-block page-footer" role="contentinfo">
    <div class="row justify-content-center">
      <div class="col-7">
        <img src="/img/footer.png" width="100%" />

        <div>
          <span class="hidden-md-down fw-700">
            {{ version }} {{ buildDate | moment('YYYY') }} &copy; {{ appTitle }} by&nbsp;
            <a href="https://witkac.pl" class="fw-500" target="_blank">Witkac sp. z o.o.</a>
          </span>

          <a v-for="(link, index) in footerLinks" :key="`${link.url}-${index}`" class="ml-3" :href="link.url">
            {{ link.text }}
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapState } from 'vuex';

import { PublicSettings } from '@/enums/publicSettings.enum';

// @vuese
// Stopka
// @group AppLayout
export default {
  name: 'Footer',
  computed: {
    copyYear() {
      return new Date().getFullYear();
    },
    ...mapState({
      version: state => state.system.packageVersion,
      appTitle: state => state.system.appTitle,
      buildDate: state => new Date(state.system.buildDate),
      footerLinksRaw: state => state.setting.settings[PublicSettings.FOOTER_LINKS]?.value
    }),

    footerLinks() {
      if (!this.footerLinksRaw) {
        return [];
      }

      try {
        const links = JSON.parse(this.footerLinksRaw);
        return Array.isArray(links)
          ? links.filter(link => link && typeof link.text === 'string' && typeof link.url === 'string')
          : [];
      } catch (error) {
        return [];
      }
    }
  }
};
</script>
